(function () {
  'use strict';

  var translations = {
  "SHARE YOUR THOUGHTS": "COMPARTE TU OPINIÓN",
  "Share your thoughts": "Comparte tu opinión",
  "Rate your experience": "Califica tu experiencia",
  "Rate your experience *": "Califica tu experiencia *",
  "Write a review": "Escribe una reseña",
  "Write a review *": "Escribe una reseña *",
  "Tell us what you like or dislike": "Cuéntanos qué te gustó o qué no te gustó",
  "Add a headline": "Agrega un título",
  "Add a headline *": "Agrega un título *",
  "Summarize your experience": "Resume tu experiencia",
  "Your name": "Tu nombre",
  "Your name *": "Tu nombre *",
  "Your email address": "Tu correo electrónico",
  "Your email address *": "Tu correo electrónico *",
  "We'll send you an email to verify this review came from you.": "Te enviaremos un correo para verificar que esta reseña fue escrita por ti.",
  "Add media": "Agregar fotos o videos",
  "Upload": "Subir archivo",
  "* required fields": "* campos obligatorios",
  "required fields": "campos obligatorios",
  "Send": "Enviar"
};

  function translated(value) {
    if (typeof value !== 'string') return null;
    var trimmed = value.trim();
    return Object.prototype.hasOwnProperty.call(translations, trimmed)
      ? translations[trimmed]
      : null;
  }

  function translateElement(element) {
    if (!element || element.nodeType !== 1) return;
    var tag = element.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return;

    var attributes = ['placeholder', 'aria-label', 'title'];
    for (var i = 0; i < attributes.length; i += 1) {
      var attribute = attributes[i];
      var current = element.getAttribute && element.getAttribute(attribute);
      var replacement = translated(current);
      if (replacement) element.setAttribute(attribute, replacement);
    }

    if ((tag === 'INPUT' || tag === 'BUTTON') && element.value) {
      var valueReplacement = translated(element.value);
      if (valueReplacement) element.value = valueReplacement;
    }
  }

  function translateRoot(root) {
    if (!root) return;
    if (root.nodeType === 1) translateElement(root);

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent || parent.closest('script, style, textarea')) continue;
      var replacement = translated(node.nodeValue);
      if (replacement) {
        var leading = (node.nodeValue.match(/^\s*/) || [''])[0];
        var trailing = (node.nodeValue.match(/\s*$/) || [''])[0];
        node.nodeValue = leading + replacement + trailing;
      }
    }

    var elements = root.querySelectorAll ? root.querySelectorAll('input, button, [placeholder], [aria-label], [title]') : [];
    for (var i = 0; i < elements.length; i += 1) translateElement(elements[i]);
  }

  function start() {
    translateRoot(document.body);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
          translateRoot(mutations[i].addedNodes[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
